export default __webpack_public_path__ + "static/betql-hero-right-6fa8d6568a3a2e61b0f9685b8fd63bbd.avif";